import { observer } from 'mobx-react-lite'
import { ChooseNumberCommon } from 'pages/settings/ui/ChooseNumberCommon/ChooseNumberCommon'
import { useBuyNumberStepsContext } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/BuyNumber/context/useBuyNumberStepsContext'

export const ChooseNumber = observer(() => {
  const {
    chooseNumberStore: {
      chooseNumberTabsStore,
      useCases,
      selectedUseCaseId,
      nextDisabled,
      setUseCase,
      nextClick,
    },
  } = useBuyNumberStepsContext()

  return (
    <ChooseNumberCommon
      chooseNumberTabsStore={chooseNumberTabsStore}
      useCases={useCases}
      selectedUseCaseId={selectedUseCaseId}
      nextDisabled={nextDisabled}
      setUseCase={setUseCase}
      nextClick={nextClick}
    />
  )
})
